
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import "../../assets/css/DentalProfessionals.css";

// Help Center Images
import heroImage from "../../assets/img/new-pro/ai-dental-hero.png";
import knowledgeBaseImg from "../../assets/img/new-pro/knowledge-base.png";
import videoTutorialsImg from "../../assets/img/new-pro/video-tutorials.png";
import liveWebinarsImg from "../../assets/img/new-pro/live-webinars.png";
import communityForumImg from "../../assets/img/new-pro/community-forum.png";
import supportTeamImg from "../../assets/img/new-pro/support-team.png";

// Pricing Images
import individualImg from "../../assets/img/new-pro/individual-tools.png";
import bundledImg from "../../assets/img/new-pro/bundled-solutions.png";
import enterpriseImg from "../../assets/img/new-pro/enterprise-solutions.png";
// Images
import practiceImg from "../../assets/img/new-pro/practice-management.png";
import ehrImg from "../../assets/img/new-pro/ehr-emr.png";
import imagingImg from "../../assets/img/new-pro/imaging-systems.png";
import communicationImg from "../../assets/img/new-pro/communication-platforms.png";
// Images
import adminImg from "../../assets/img/new-pro/admin-tasks.png";
import communication from "../../assets/img/new-pro/patient-communication.png";
import diagnosticImg from "../../assets/img/new-pro/diagnostic-accuracy.png";

// Icons / Images
import dotImg from "../../assets/img/new-pro/ai-step-icon.png";
import curveLine from "../../assets/img/new-pro/curveLine.png";

// Images
import patientImg from "../../assets/img/new-pro/patient-management.png";
import clinicalImg from "../../assets/img/new-pro/clinical-tools.png";
import analyticsImg from "../../assets/img/new-pro/practice-analytics.png";
import imagingImgs from "../../assets/img/new-pro/imaging-diagnostics.png";
import billingImg from "../../assets/img/new-pro/billing-insurance.png";
import communicationImgs from "../../assets/img/new-pro/communication-tools.png";
import EducationImgs from "../../assets/img/new-pro/EducationImgs.png";
import SchedulingImgs from "../../assets/img/new-pro/SchedulingImgs.png";
import MarketingImgs from "../../assets/img/new-pro/MarketingImgs.png";
import ComplianceImgs from "../../assets/img/new-pro/ComplianceImgs.png";
import EcosystemImgs from "../../assets/img/new-pro/EcosystemImgs.png";

const suiteFeatures = [
  {
    title: "Patient Management",
    desc: "Tools for managing patient records and information",
    image: patientImg,
  },
  {
    title: "Clinical Tools",
    desc: "Clinical decision support and treatment planning",
    image: clinicalImg,
  },
  {
    title: "Practice Analytics",
    desc: "Analytics and reporting for dental practices",
    image: analyticsImg,
  },
  {
    title: "Imaging & Diagnostics",
    desc: "Dental imaging and diagnostic tools",
    image: imagingImgs,
  },
  {
    title: "Billing & Insurance",
    desc: "Billing, insurance, and payment processing",
    image: billingImg,
  },
  {
    title: "Communication",
    desc: "Patient communication and engagement tools",
    image: communicationImgs,
  },
  {
    title: "Education & Training",
    desc: "Educational resources and training tools",
    image: EducationImgs,
  },
  {
    title: "Scheduling",
    desc: "Appointment scheduling and calendar management",
    image: SchedulingImgs,
  },
  {
    title: "Marketing",
    desc: "Marketing and patient acquisition tools",
    image: MarketingImgs,
  },
  {
    title: "Compliance & Security",
    desc: "HIPAA compliance and security tools",
    image: ComplianceImgs,
  },
  {
    title: "Ecosystem",
    desc: "Apps connecting multiple platforms in one place.",
    image: EcosystemImgs,
  },
];


// ================= JSON DATA =================
const stepsData = [
  {
    id: 1,
    stepClass: "steps1",
    title: "Discover",
    points: [
      "Browse by category or search by need",
      "Filter by price, features, integrations",
      "Read reviews from other dental professionals"
    ]
  },
  {
    id: 2,
    stepClass: "steps2",
    title: "Evaluate",
    points: [
      "View detailed product information",
      "Watch demos and tutorials",
      "Request trials or demos",
      "Compare multiple solutions"
    ]
  },
  {
    id: 3,
    stepClass: "steps3",
    title: "Purchase",
    points: [
      "Transparent pricing with no hidden fees",
      "Flexible subscription options",
      "Secure payment processing"
    ]
  },
  {
    id: 4,
    stepClass: "steps4",
    title: "Implement",
    points: [
      "Integration support and documentation",
      "Training resources and webinars",
      "Ongoing customer support",
      "Community access"
    ]
  }
];

const challengesData = [
  {
    id: 1,
    icon: adminImg,
    title: "Time Consuming Administrative Tasks",
    problem: "Manual scheduling, documentation, billing",
    solution: "AI-powered automation tools",
    delay: "delay-1"
  },
  {
    id: 2,
    icon: communication,
    title: "Patient Communication Gaps",
    problem: "Missed appointments, low engagement",
    solution: "Smart communication platforms",
    delay: "delay-2"
  },
  {
    id: 3,
    icon: diagnosticImg,
    title: "Diagnostic Accuracy & Efficiency",
    problem: "Time-intensive analysis, second opinions needed",
    solution: "AI-assisted diagnostic tools",
    delay: "delay-3"
  }
];

// JSON DATA
const integrationCards = [
  {
    id: 1,
    title: "Practice Management\\nSoftware",
    image: practiceImg,
    delay: "delay-1"
  },
  {
    id: 2,
    title: "EHR/EMR\\nPlatforms Software",
    image: ehrImg,
    delay: "delay-2"
  },
  {
    id: 3,
    title: "Imaging\\nSystems",
    image: imagingImg,
    delay: "delay-3"
  },
  {
    id: 4,
    title: "Communication\\nPlatforms",
    image: communicationImg,
    delay: "delay-4"
  }
];

const securityPoints = [
  {
    id: 1,
    title: "HIPAA Compliant",
    desc: "Full compliance with healthcare regulations"
  },
  {
    id: 2,
    title: "End-to-End Encryption",
    desc: "Your data is encrypted at all times"
  },
  {
    id: 3,
    title: "Regular Security Audits",
    desc: "Continuous monitoring and testing"
  },
  {
    id: 4,
    title: "Data Privacy Guaranteed",
    desc: "We never share your information"
  }
];

/* ---------------- HELP CARDS ---------------- */

const cards = [
  {
    title: "Knowledge Base",
    desc: "Setup guides and FAQs",
    image: knowledgeBaseImg,
  },
  {
    title: "Video Tutorials",
    desc: "Step-by-step walkthroughs",
    image: videoTutorialsImg,
  },
  {
    title: "Live Webinars",
    desc: "Setup guides and FAQs",
    image: liveWebinarsImg,
  },
  {
    title: "Community Forum",
    desc: "Connect with peers",
    image: communityForumImg,
  },
  {
    title: "Support Team",
    desc: "Get personalized help",
    image: supportTeamImg,
  },
];

/* ---------------- PRICING PLANS ---------------- */

const plans = [
  {
    title: "Individual Tools",
    image: individualImg,
    features: [
      "Pay for specific solutions",
      "Monthly or annual subscriptions",
      "Scale as you grow",
    ],
    highlight: false,
  },
  {
    title: "Bundled Solutions",
    image: bundledImg,
    features: [
      "Save with category bundles",
      "Comprehensive practice coverage",
      "Discounted rates",
    ],
    highlight: false,
  },
  {
    title: "Enterprise Solutions",
    image: enterpriseImg,
    features: [
      "Custom packages for groups",
      "Multi-location support",
      "Dedicated account management",
    ],
    highlight: false,
  },
];

const faqData = [
  {
    question: "How do I choose the right AI tool?",
    answer:
      "We help match you with tools that fit your practice needs, budget, and workflow requirements."
  },
  {
    question: "What are the typical costs?",
    answer:
      "Pricing varies based on your chosen tools, subscription plans, and required integrations."
  },
  {
    question: "What if I need help with implementation?",
    answer:
      "Our onboarding team provides full support with setup, training, and ongoing guidance."
  },
  {
    question: "Can I try before I buy?",
    answer:
      "Most tools offer free trials or demo access so you can evaluate before committing."
  },
  {
    question: "Are these tools HIPAA compliant?",
    answer:
      "Yes, all tools listed on our platform are thoroughly vetted for HIPAA compliance. We prioritize your data security and only feature solutions that meet healthcare industry standards."
  }
];



const HelpCenter = () => {
  const navigate = useNavigate();
  const [activeIndex, setActiveIndex] = useState(null); // all items closed by default

  const toggleFAQ = (index) => {
    setActiveIndex((prevIndex) =>
      prevIndex === index ? null : index
    );
  };

  

  return (
    <>
      {/* ================= Help Center Section ================= */}

      <section className="eco-pro-bg-main">
        <section className="hero-section">
          <div className="hero-container">

            {/* Left Content */}
            <div className="hero-content-main fade-in-left">
              <h1>
                AI-Powered
                Tools Built for
                <span> Dental Professionals</span>
              </h1>

              <p>
                Discover, compare, and integrate cutting-edge AI solutions that
                enhance patient care and practice efficiency.
              </p>

              <div className="hero-actions">
                <button className="btn-primary" onClick={() => navigate('/marketplace/categories')}>Browse AI Tools</button>
                {/* <button className="btn-secondary">Schedule A Demo</button> */}
              </div>
            </div>

            {/* Right Image */}
            <div className="hero-image fade-in-right">
              <img src={heroImage} alt="AI Dental Tools" />
            </div>

          </div>
        </section>

        <section className="challenges-section">
          <div className="container">
            {/* Header */}
            <div className="challenges-header animate-fade-up">
              <h2>
                Challenges Dental Practices Face Today
              </h2>
              <p>
                Dental practices balance clinical excellence with operational
                workloads. Managing patient flow, records, and personalized care
                can lead to bottlenecks, inconsistent communication, and delays,
                impacting patient satisfaction and growth.
              </p>
            </div>


            {/* Cards */}
            <div className="challenges-grid">
              {challengesData.map((item) => (
                <div
                  key={item.id}
                  className={`challenge-card animate-fade-up ${item.delay}`}
                >
                  <div className="challenge-icon">
                    <img src={item.icon} alt={item.title} />
                  </div>


                  <h4>{item.title}</h4>


                  <div className="challenge-block">
                    <span className="label">Problem</span>
                    <p>{item.problem}</p>
                  </div>


                  <div className="divider" />


                  <div className="challenge-block">
                    <span className="label">Solution</span>
                    <p>{item.solution}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>
        <section className="suite-section">
          <div className="suite-container">

            {/* Header */}
            <div className="suite-header fade-down">
              <h2>
                Dental Practice Management Suite
              </h2>
              <p>
                Comprehensive tools to streamline your dental practice operations,
                from patient management to compliance.
              </p>
            </div>

            <div className="suite-grid">
              {suiteFeatures.map((item, index) => (
                <div
                  key={index}
                  className="suite-card fade-up"
                  style={{ animationDelay: `${index * 0.1}s` }}
                >
                  <div className="suite-card-icon">
                    <img src={item.image} alt={item.title} />
                  </div>

                  <h4>{item.title}</h4>
                  <p>{item.desc}</p>
                </div>
              ))}
            </div>

          </div>
        </section>
        <section className="steps-section home-sec-pages">
          <div className="steps-container container">
            {/* Title */}
            <h2 className="steps-title">
              Your Journey to AI-Enhanced Practice
            </h2>


            <p className="steps-subtext">
              Transform your dental practice with AI easily. Our guided journey helps
              you explore tools, evaluate their impact, and integrate them into your
              workflow. Whether streamlining operations, enhancing patient
              experiences, or improving diagnostics, each step gives you the clarity
              and confidence to adopt AI solutions that advance your practice.
            </p>


            <button
              className="steps-btn"
              onClick={() => navigate("/marketplace/categories")}
            >
              Start Exploring AI Tools
            </button>


            {/* Curve Line Image */}
            <div className="steps-path">
              <img src={curveLine} alt="Curve Line" className="curve-img" />


              {/* Steps from JSON */}
              {stepsData.map((step, index) => (
                <div
                  key={step.id}
                  className={`step-item ${step.stepClass}`}
                >
                  <div className="step-dot-wrapper">
                    <img src={dotImg} alt="Dot" className="step-dot-img" />
                  </div>


                  <div className="step-content">
                    <h4>{step.title}</h4>
                    <ul>
                      {step.points.map((point, idx) => (
                        <li key={idx}>{point}</li>
                      ))}
                    </ul>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>
        <section className="integration-section">
          <div className="integration-container">
            {/* Left Cards */}
            <div className="integration-cards">
              {integrationCards.map((item) => (
                <div
                  key={item.id}
                  className={`integration-card animate-fade-up ${item.delay}`}
                >
                  <img src={item.image} alt={item.title} />
                  <h4>{item.title.split("\n").map((t, i) => (<span key={i}>{t}<br /></span>))}</h4>
                </div>
              ))}
            </div>


            {/* Right Content */}
            <div className="integration-content animate-slide-right">
              <h2>
                Seamlessly Integrates with
                Your Existing Systems
              </h2>
              <p>
                No need to change your workflow. Our platform connects with your
                existing tools, ensuring smooth data flow and minimal setup. Every
                integration enhances efficiency, allowing your team to focus on
                patient care.
              </p>


              <ul className="security-list">
                {securityPoints.map((point, index) => (
                  <li key={point.id}>
                    <span className="security-number">{index + 1}</span>
                    <div className="security-text">
                      <strong>{point.title}</strong>
                      <span>{point.desc}</span>
                    </div>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </section>

        {/* ================= Pricing Section ================= */}
        <section className="pricing-section">
          <div className="container">
            <h2 className="pricing-title">Transparent Pricing, Maximum Value</h2>
            <p className="pricing-subtitle">
              Choose a plan that fits your practice without hidden fees or
              long-term lock-ins. Whether you need a tool, bundled solution, or
              enterprise package, our pricing offers maximum value at every growth
              stage.
            </p>

            <div className="pricing-grid">
              {plans.map((plan, index) => (
                <div
                  key={index}
                  className="pricing-card fade-up"
                  style={{ animationDelay: `${index * 0.15}s` }}
                >
                  <img
                    src={plan.image}
                    alt={plan.title}
                    className="pricing-img"
                  />

                  <h4>{plan.title}</h4>

                  <ul>
                    {plan.features.map((feature, i) => (
                      <li key={i}>{feature}</li>
                    ))}
                  </ul>

                  <button className="btn-learn" onClick={() => navigate('/marketplace/categories')}>Learn More</button>
                </div>
              ))}
            </div>
          </div>
        </section>


        <section className="help-section">
          <div className="container">
            <h2 className="help-title">We're Here to Help You Succeed</h2>
            <p className="help-subtitle">
              Whether starting or mastering features, we offer resources to grow
              confidently. From guides and webinars to community support, help is
              always available.
            </p>

            <div className="help-grid">
              {cards.map((item, index) => (
                <div
                  key={index}
                  className="help-card fade-up"
                  style={{ animationDelay: `${index * 0.15}s` }}
                >
                  <div className="help-icon">
                    <img src={item.image} alt={item.title} />
                  </div>
                  <h4>{item.title}</h4>
                  <p>{item.desc}</p>
                </div>
              ))}
            </div>
          </div>
        </section>







        <section className="faq-section">
          <div className="container">
            <h2 className="faq-title">
              Have questions?
              <span>Get answers</span>
            </h2>

            <div className="faq-list">
              {faqData.map((item, index) => (
                <div
                  key={index}
                  className={`faq-item ${activeIndex === index ? "active" : ""}`}
                >
                  <button
                    className="faq-question"
                    onClick={() => toggleFAQ(index)}
                  >
                    <span className="faq-question-text">
                      {item.question}</span>
                    <span className="faq-icon">
                      {activeIndex === index ? "−" : "+"}
                    </span>
                  </button>

                  <div className="faq-answer">
                    <p>{item.answer}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>
      </section>
    </>
  );
};

export default HelpCenter;
